var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPiggyBankRiding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 140,
    height: 130,
    viewBox: "0 0 140 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Piggy-bank-riding-"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.264 81.412L117.535 84.9494L115.33 93.307C113.323 100.91 105.574 105.444 98.0081 103.453L104.264 81.412Z",
    fill: "#D40199"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09157 78.9304C5.71697 80.0217 6.10358 81.5545 6.99406 82.8795C7.65503 82.9306 8.35011 82.8771 9.07194 82.7154L9.10012 82.7102C10.9551 82.4352 11.538 81.1153 11.4737 80.0684C11.3939 78.7722 10.3695 77.4386 8.5652 77.39C7.26857 77.4605 6.41333 77.9929 6.09157 78.9304ZM7.67937 84.8489C7.25592 84.479 6.8773 84.0648 6.5501 83.6237C4.1833 83.2987 2.21033 81.7531 1.02773 79.1935C-0.766355 75.3107 -0.359235 69.3283 3.4272 66.4337L3.90511 67.065C0.43114 69.721 0.0783141 75.255 1.74379 78.8593C2.69897 80.9266 4.16937 82.2433 5.96441 82.7089C5.21263 81.3309 4.94773 79.8298 5.34524 78.6715C5.77558 77.4177 6.90998 76.6808 8.53941 76.5968L8.55399 76.5962L8.56872 76.5963C10.8582 76.6491 12.1594 78.3583 12.2616 80.0195C12.3531 81.508 11.4509 83.1573 9.22969 83.4929C8.68243 83.6146 8.14671 83.6786 7.6254 83.6871C7.80445 83.885 7.99536 84.0738 8.19732 84.2501C10.029 85.8506 12.2917 86.1468 14.4052 85.0636L14.7639 85.7702C13.8035 86.2627 12.8171 86.5061 11.8454 86.5061C10.3739 86.5061 8.9366 85.9473 7.67937 84.8489Z",
    fill: "#D40199"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9449 66.0016L77.2333 47.1962C75.1331 45.0856 71.5423 46.5805 71.5423 49.5653V66.0016H95.9449Z",
    fill: "#D40199"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.71 129.815V111.17L24.0158 108.832L32.6272 129.815H38.71Z",
    fill: "#D40199"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.923 129.815V111.17H62.5546L68.8403 129.815H74.923Z",
    fill: "#D40199"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.151 103.696C97.0214 109.299 90.8038 113.253 83.6532 114.398V129.815H77.5703L72.4884 114.74H47.4401V129.815H41.3573L36.1314 114.313C23.4531 112.034 13.83 100.896 13.83 87.4988C13.83 72.454 25.9654 60.2577 40.9353 60.2577H62.4504L80.5234 60.2844C94.2214 60.8676 105.288 71.6663 106.374 85.2956C106.374 85.2956 107.237 97.192 101.151 103.696Z",
    fill: "#F689FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.0531 78.5479C98.0531 77.3777 97.1093 76.4291 95.9449 76.4291C94.7806 76.4291 93.8368 77.3777 93.8368 78.5479C93.8368 79.718 94.7806 80.6667 95.9449 80.6667C97.1093 80.6667 98.0531 79.718 98.0531 78.5479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2495 63.6359V63.6354C63.2495 62.9955 62.7331 62.4767 62.096 62.4767H44.5117C43.8748 62.4767 43.3583 62.9955 43.3583 63.6354V63.6359C43.3583 64.2757 43.8748 64.7946 44.5117 64.7946H62.096C62.7331 64.7946 63.2495 64.2757 63.2495 63.6359Z",
    fill: "#D40199"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2759 60.3998V50.3728C62.2759 47.38 65.8762 45.8813 67.9818 47.9974L80.3489 60.4265",
    fill: "#F689FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.7703 72.2303H96.147C97.5257 72.2303 98.8215 72.8912 99.6354 74.0094H92.282C93.0959 72.8912 94.3917 72.2303 95.7703 72.2303Z",
    fill: "#D40199"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3755 26.711L57.5009 18.764L54.4602 19.0014L53.9055 28.9855L56.1162 29.0987C57.438 29.1662 58.5091 28.0344 58.3755 26.711Z",
    fill: "#F5B091"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8693 56.4418L62.6582 57.0925C62.9149 57.1366 63.0874 57.3813 63.0435 57.6392L63.0324 57.7045C62.9886 57.9624 62.745 58.1357 62.4882 58.0916L58.6994 57.441L58.8693 56.4418Z",
    fill: "#FFC6AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9254 25.9864L53.05 37.4381L56.4298 38.2101L58.3384 27.3163L53.9254 25.9864Z",
    fill: "#F5B091"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9861 24.8583L57.4594 18.1857L54.4917 18.0219L54.1454 24.6743L57.9861 24.8583Z",
    fill: "#F5B091"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2492 18.8609L58.4017 15.8704L54.392 15.4327L54.478 18.6429L57.2492 18.8609Z",
    fill: "#F5B091"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4027 13.4647C59.124 13.2763 58.7461 13.3507 58.5587 13.6306L56.6542 16.4753L57.5964 17.2579L59.5678 14.3131C59.7554 14.033 59.6814 13.6531 59.4027 13.4647Z",
    fill: "#FFC6AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9141 12.7722V12.7719C59.9071 12.4345 59.6292 12.1668 59.2932 12.1737L56.6098 12.23L56.6351 13.4522L59.3187 13.396C59.6545 13.3889 59.9212 13.1096 59.9141 12.7722Z",
    fill: "#FFD4C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.642 11.3873C59.4958 11.0834 59.1321 10.9558 58.8295 11.1025L56.4126 12.2757L56.9416 13.3764L59.3588 12.2032C59.6612 12.0564 59.7881 11.6912 59.642 11.3873Z",
    fill: "#FFD4C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3887 15.4336L55.4152 16.0894L57.4383 12.9436L56.4118 12.2879L54.3887 15.4336Z",
    fill: "#F5B091"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9013 15.9054L55.9189 16.5749L57.9889 13.397L56.9713 12.7274L54.9013 15.9054Z",
    fill: "#F5B091"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-42",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7502 14.8371C57.7502 14.8371 57.4445 15.2634 57.2957 15.4427C57.0551 15.7326 56.7166 15.3973 56.8844 15.1273C56.9919 14.9542 57.6214 13.9615 57.6214 13.9615L55.0942 15.4092L57.2729 16.5155L57.7502 14.8371Z",
    fill: "#F5B091"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-44",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2349 39.6259C51.2313 39.6525 51.2253 39.678 51.2223 39.7049C51.0684 41.131 52.0939 42.4124 53.5129 42.5673C54.9051 42.7192 55.7302 44.0752 55.9224 42.6907L56.4079 40.0074L56.8456 37.939L51.821 37.2323L51.2322 39.6256L51.2349 39.6259Z",
    fill: "#123A4F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-48",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5496 40.0372L54.5943 35.2249L49.578 33.7499L49.4811 41.3671L51.9981 41.3995C53.3883 41.4173 54.5305 41.5293 54.5496 40.0372Z",
    fill: "#FFC6AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-50",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0106 33.2774L49.0675 31.7258C49.0894 30.0043 50.4957 28.6267 52.2086 28.6487L54.4039 28.6769C56.1168 28.6989 57.4876 30.1124 57.4658 31.8337L57.3887 34.9602C57.3779 35.8119 56.6821 36.4936 55.8346 36.4827L52.0723 36.4343C50.3594 36.4122 48.9887 34.999 49.0106 33.2774Z",
    fill: "#FFC6AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-52",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5365 25.5626C51.3812 25.5626 49.6315 27.3212 49.6315 29.4871C49.6315 31.6531 51.3812 33.4117 53.5365 33.4117C55.6917 33.4117 57.4414 31.6531 57.4414 29.4871C57.4414 27.3212 55.6917 25.5626 53.5365 25.5626Z",
    fill: "#FFC6AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-54",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8836 32.6778L52.6545 34.4518C52.6545 35.2201 52.0349 35.8427 51.2705 35.8427H48.7356V28.277L48.6077 28.2776L53.0115 28.4321",
    fill: "#420F0F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-56",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.1406 32.3549C58.1464 31.8991 57.1922 30.6698 57.1922 30.6698L57.2404 33.086C57.2404 33.086 58.1349 32.8107 58.1406 32.3549Z",
    fill: "#FFC6AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-58",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.907 27.3544C57.9193 26.3921 57.153 25.6022 56.1955 25.5898L51.5305 25.5199C49.7109 25.4964 48.3443 27.1831 48.7357 28.9691H48.7614L56.1512 29.0743C57.1086 29.0867 57.8948 28.3167 57.907 27.3544Z",
    fill: "#420F0F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-60",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3715 34.3247C52.3971 34.299 52.8835 31.8544 53.959 29.9357L54.2541 28.5642",
    fill: "#420F0F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-62",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1261 26.5577V31.1362C54.3841 31.1362 55.404 30.1113 55.404 28.847C55.404 27.5826 54.3841 26.5577 53.1261 26.5577Z",
    fill: "#420F0F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-64",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.37 31.1337L56.0685 25.5629L49.7482 25.4655C49.1742 25.4567 48.6234 25.6938 48.2338 26.1176L46.826 27.6487L52.7755 30.986L53.37 31.1337Z",
    fill: "#E73245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-66",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.775 32.0006C53.7826 31.4021 53.306 30.9108 52.7106 30.9032C52.1151 30.8955 51.6261 31.3745 51.6184 31.973C51.6109 32.5713 52.0874 33.0627 52.6828 33.0704C53.2785 33.0781 53.7673 32.5992 53.775 32.0006Z",
    fill: "#FFC6AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-68",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8369 30.9159C56.8369 30.9159 57.1054 31.2908 56.8624 31.7492C56.8624 31.7492 56.1298 31.9237 55.5992 31.094C55.5992 31.094 56.3079 30.8591 56.8369 30.9159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    d: "M56.8304 30.8814C56.8762 30.9513 57.0847 31.309 56.8634 31.7441C56.8634 31.7441 56.7188 31.7812 56.5085 31.7525C56.4133 31.6668 56.3478 31.5266 56.3402 31.3656C56.3286 31.1187 56.4568 30.9077 56.6354 30.8629C56.6469 30.8627 56.6583 30.8626 56.6697 30.8626C56.7108 30.8626 56.7514 30.8639 56.791 30.8666C56.8044 30.8706 56.8175 30.8756 56.8304 30.8814Z",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-74",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9609 30.9248L56.957 30.7979C56.957 30.7979 56.1918 30.6089 55.4427 30.9396L55.6433 31.1763C55.6433 31.1763 56.1937 30.924 56.9609 30.9248Z",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-76",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3551 29.8737L56.312 29.8746C55.8634 29.8877 55.4488 30.0777 55.1919 30.3879L57.5178 30.3219C57.2336 30.0268 56.8037 29.8608 56.3551 29.8737Z",
    fill: "#420F0F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-78",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4107 34.0131C57.4112 33.8733 57.2987 33.7597 57.1596 33.7597H55.9332C55.9396 33.7229 56.5321 34.6396 57.3514 34.7109C57.3681 34.7124 57.3943 34.7125 57.3956 34.7141C57.3959 34.7145 57.4107 34.0131 57.4107 34.0131Z",
    fill: "#E73245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-80",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6033 99.9201L41.6867 98.0452L44.992 88.9019L49.8419 91.227L45.6033 99.9201Z",
    fill: "#FFC6AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-82",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7055 95.2272C42.7055 95.2272 42.5913 96.8065 44.1003 97.5288C45.5146 98.206 46.9668 97.229 46.9668 97.229L49.5768 99.0568C50.9505 100.14 51.5988 101.006 50.8715 102.442L41.6867 98.0454L41.4284 97.9218L42.7055 95.2272Z",
    fill: "#123A4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-84",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9424 98.947L50.3856 103.467L50.8715 102.442L41.4283 97.9217L40.9424 98.947Z",
    fill: "#FBB03B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-86",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9259 58.2566C45.5616 56.3734 45.9533 54.8859 46.415 53.301L47.672 49.9258L57.6642 51.4961L57.7201 56.8475L60.5713 73.2204C60.8036 74.5547 60.5606 75.5907 59.9754 77.132L52.5037 97.7547L43.0473 93.5004L50.1289 74.7484",
    fill: "#FBB03B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-88",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1938 39.2406C53.6233 39.4789 54.5474 39.7151 54.5474 39.7151C55.3774 40.9168 57.1389 42.7633 57.3201 44.2147L57.6643 51.4962H45.8938L47.3786 39.2395C47.6186 37.3962 50.3755 37.791 52.1922 38.1416C52.1922 38.1416 52.471 38.8397 53.1938 39.2406Z",
    fill: "#2C4F65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-90",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2233 49.1607L52.7231 40.8696L47.6633 40.2151L49.138 50.8891C49.3409 52.3581 50.741 53.3939 52.2717 53.2076L53.4094 53.069L53.2233 49.1607Z",
    fill: "#FFC6AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-92",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.602 39.2694C52.5985 39.2421 52.5974 39.2149 52.5931 39.1876C52.3575 37.7288 50.9899 36.7383 49.5382 36.975C48.1141 37.2073 47.1413 38.5353 47.3277 39.9632L47.3248 39.9635L47.941 46.4846L53.221 45.7902L52.6049 39.2691L52.602 39.2694Z",
    fill: "#2C4F65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-94",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1849 59.1753L61.7833 61.6606C61.9623 61.8317 61.9692 62.1164 61.799 62.2962L61.7559 62.3416C61.5855 62.5216 61.302 62.5286 61.1229 62.3574L58.5249 59.8723L59.1849 59.1753Z",
    fill: "#FFC6AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-96",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4337 49.8592L59.2911 56.7467L57.5643 58.799L50.3001 52.792C49.2983 51.9637 49.28 50.4793 50.2608 49.6284C51.1928 48.8199 52.6393 48.9253 53.4337 49.8592Z",
    fill: "#FFC6AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-98",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8256 56.4331L61.4349 57.6172L59.2456 60.5408L57.1714 58.5369L58.8256 56.4331Z",
    fill: "#FFC6AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-100",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7709 58.4214L63.8935 61.1617C64.0796 61.325 64.0987 61.609 63.9363 61.7959L63.8951 61.8432C63.7325 62.0304 63.4497 62.0497 63.2634 61.8862L60.1412 59.1462L60.7709 58.4214Z",
    fill: "#FFC6AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-102",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1155 57.5775L64.1159 60.2106C64.302 60.3739 64.3212 60.6579 64.1586 60.8448L64.1176 60.8921C63.9551 61.0793 63.6721 61.0986 63.486 60.9351L60.4857 58.3023L61.1155 57.5775Z",
    fill: "#FFC6AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-104",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1354 59.0655L62.8374 61.4368C63.0235 61.6001 63.0426 61.884 62.8802 62.071L62.839 62.1183C62.6765 62.3054 62.3936 62.3247 62.2074 62.1612L59.5057 59.7904L60.1354 59.0655Z",
    fill: "#FFC6AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-106",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6538 48.2356C50.6129 47.9724 50.792 47.7258 51.0538 47.6847C51.0708 47.6822 51.0875 47.6804 51.1041 47.6796C51.4331 47.6627 51.627 48.0511 51.4381 48.322L50.8618 49.148L50.0737 48.5334C49.815 48.3318 49.8842 47.9084 50.2 47.8217C50.2172 47.817 50.2348 47.8131 50.2529 47.8104C50.5148 47.7694 50.7601 47.9494 50.801 48.2125",
    fill: "#191C15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-108",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1775 9.16693C55.1775 14.2297 59.2612 18.3339 64.2987 18.3339C69.3362 18.3339 73.4199 14.2297 73.4199 9.16693C73.4199 4.10417 69.3362 0 64.2987 0C59.2612 0 55.1775 4.10417 55.1775 9.16693Z",
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-110",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9093 2.62733L70.8058 15.5884C69.1507 17.2821 66.8473 18.3338 64.2987 18.3338C59.2612 18.3338 55.1775 14.2297 55.1775 9.16707C55.1775 6.60552 56.2239 4.29062 57.9093 2.62733Z",
    fill: "#EF7903"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-112",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9429 9.22623C56.9429 13.2763 60.2098 16.5596 64.2398 16.5596C68.2699 16.5596 71.5369 13.2763 71.5369 9.22623C71.5369 5.17612 68.2699 1.89281 64.2398 1.89281C60.2098 1.89281 56.9429 5.17612 56.9429 9.22623Z",
    fill: "#FBB03B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-114",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4027 13.4647C59.124 13.2763 58.746 13.3507 58.5586 13.6306L56.6542 16.4753L57.5964 17.2579L59.5678 14.3131C59.7553 14.033 59.6813 13.6531 59.4027 13.4647Z",
    fill: "#F5B091"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-117",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.396 124.343V128.2C137.396 129.194 132.833 130 127.205 130C121.576 130 117.014 129.194 117.014 128.2V124.343H137.396Z",
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-119",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.011 124.328C117.111 123.683 119.129 123.123 122.093 122.82V129.743C119.051 129.431 117.003 128.85 117.003 128.185V124.328H117.011Z",
    fill: "#EF7903"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-121",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.014 124.343C117.014 125.337 121.576 126.143 127.205 126.143C132.833 126.143 137.396 125.337 137.396 124.343C137.396 123.349 132.833 122.543 127.205 122.543C121.576 122.543 117.014 123.349 117.014 124.343Z",
    fill: "#FBB03B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-123",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.099 123.608C118.733 123.963 118.705 124.366 118.705 124.383C118.705 124.4 118.733 124.802 121.099 125.157C122.71 125.399 124.853 125.532 127.134 125.532C129.415 125.532 131.558 125.399 133.169 125.157C135.536 124.802 135.563 124.4 135.563 124.383C135.563 124.366 135.536 123.963 133.169 123.608C131.558 123.367 129.415 123.233 127.134 123.233C124.853 123.233 122.71 123.367 121.099 123.608ZM118.436 124.383C118.436 123.341 123.638 122.963 127.134 122.963C130.63 122.963 135.832 123.341 135.832 124.383C135.832 125.425 130.63 125.803 127.134 125.803C123.638 125.803 118.436 125.425 118.436 124.383Z",
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-125",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140 120.18V124.036C140 125.03 135.437 125.836 129.809 125.836C124.18 125.836 119.618 125.03 119.618 124.036V120.18H140Z",
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-127",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.615 120.164C119.715 119.52 121.733 118.96 124.697 118.656V125.579C121.655 125.268 119.607 124.687 119.607 124.021V120.164H119.615Z",
    fill: "#EF7903"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-129",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.618 120.179C119.618 121.173 124.18 121.979 129.809 121.979C135.437 121.979 140 121.173 140 120.179C140 119.185 135.437 118.38 129.809 118.38C124.18 118.38 119.618 119.185 119.618 120.179Z",
    fill: "#FBB03B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-131",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.703 119.445C121.337 119.8 121.309 120.202 121.309 120.219C121.309 120.236 121.337 120.639 123.703 120.994C125.314 121.236 127.457 121.369 129.738 121.369C132.019 121.369 134.162 121.236 135.773 120.994C138.14 120.639 138.167 120.236 138.167 120.219C138.167 120.202 138.14 119.8 135.773 119.445C134.162 119.203 132.019 119.07 129.738 119.07C127.457 119.07 125.314 119.203 123.703 119.445ZM121.04 120.219C121.04 119.178 126.242 118.799 129.738 118.799C133.234 118.799 138.436 119.178 138.436 120.219C138.436 121.261 133.234 121.639 129.738 121.639C126.242 121.639 121.04 121.261 121.04 120.219Z",
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-133",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.33 115.302V119.159C136.33 120.153 131.768 120.959 126.139 120.959C120.511 120.959 115.948 120.153 115.948 119.159V115.302H136.33Z",
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-135",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.945 115.287C116.045 114.643 118.064 114.083 121.028 113.779V120.702C117.986 120.391 115.938 119.81 115.938 119.144V115.287H115.945Z",
    fill: "#EF7903"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-137",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.948 115.302C115.948 116.296 120.511 117.102 126.139 117.102C131.768 117.102 136.33 116.296 136.33 115.302C136.33 114.308 131.768 113.502 126.139 113.502C120.511 113.502 115.948 114.308 115.948 115.302Z",
    fill: "#FBB03B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-139",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.033 114.567C117.667 114.922 117.64 115.325 117.64 115.342C117.64 115.359 117.667 115.762 120.033 116.117C121.644 116.358 123.788 116.491 126.069 116.491C128.35 116.491 130.493 116.358 132.104 116.117C134.47 115.762 134.497 115.359 134.497 115.342C134.497 115.325 134.47 114.922 132.104 114.567C130.493 114.326 128.35 114.193 126.069 114.193C123.788 114.193 121.644 114.326 120.033 114.567ZM117.371 115.342C117.371 114.3 122.572 113.922 126.069 113.922C129.565 113.922 134.767 114.3 134.767 115.342C134.767 116.384 129.565 116.762 126.069 116.762C122.572 116.762 117.371 116.384 117.371 115.342Z",
    fill: "#F7931E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggyBankRiding);
export default __webpack_public_path__ + "static/media/piggy-bank-riding.41167300d2812d559568f3bfd215ea4b.svg";
export { ForwardRef as ReactComponent };